import { instantiate } from '@classic/Shared/TemplateLoader';
import alertBadgeTemplate from '@classic/Components/PopUpAlerts/Components/AlertBadge.html?raw';

/**
 * Light-DOM custom element replicating `Legacy\PopUpAlert\BadgeTemplate`.
 * Replaces the AJAX-backed `.alert-badge` click handler in `webroot/js/general.js`
 * — recall re-opens the dialog with the alerts already held in memory, no request.
 */
class AlertBadge extends HTMLElement {
    private readonly button: HTMLButtonElement;

    constructor() {
        super();
        this.className = 'alert-badge-container hideAlertBadge';
        this.append(instantiate(alertBadgeTemplate));

        this.button = this.querySelector('.alert-badge') as HTMLButtonElement;
    }

    public setOnRecall(handler: () => void): void {
        this.button.addEventListener('click', handler);
    }

    public setVisible(visible: boolean): void {
        this.classList.toggle('hideAlertBadge', !visible);
    }
}

if (!customElements.get('ss-alert-badge')) {
    customElements.define('ss-alert-badge', AlertBadge);
}

export default AlertBadge;
